import type { TOC } from '@ember/component/template-only';

import CommonHtmlContainer from 'webapp/components/common/html-container';

import type SourceType from 'webapp/models-custom/source-type';

export interface Args {
	model: SourceType;
}

const SourceTypeInfoTabsAboutComponent: TOC<Args> = <template>
	<div class="about">
		<CommonHtmlContainer @content={{@model.extraInfo.content}} @extraClass="extra-info" />
	</div>
</template>;

export default SourceTypeInfoTabsAboutComponent;
